// extracted by mini-css-extract-plugin
export default {"lessonCard":"LessonCard_lessonCard__6g7UV","outer":"LessonCard_outer__7SLCd","inner":"LessonCard_inner__Ov7H0","buyButton":"LessonCard_buyButton__A32zs"};